import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";


export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null); // manage the state for selected row data
    const [statusLoading,setStatusLoading] = useState(false);
    const [reportsData,setReportsData]=useState([]);
    const [reportDataById,setReportDataById]=useState([]);

    const getUserList = async (request) => {
        setLoading(true);
        try {
            const response = await api.user.getAllusersList(request);
            if (response?.success) {
                setData(response.data.docs);
                setTotalCount(response?.data.totalDocs);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const getUserListById = async (id) => {
        setLoading(true);
        try {
            const response = await api.user.getUserDetailsById(id);
            if (response?.success) {
                setLoading(false);
                setUserData(response?.data[0]);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const advisorUserChangeStatus = async (request) => {
        setStatusLoading(true);
        try {
            const response = await api.user.approveRejectStatus(request);
            if (response?.success) {
                setStatusLoading(false);
                toast.success(response?.message);
                getUserList();
            }
        } catch (error) {
            setStatusLoading(false);
            toast.error(error?.message);
        } finally {
            setStatusLoading(false);
        }
    };


    const getAllReportsList = async (request) => {
        setLoading(true);
        try {
            const response = await api.report.getAllreportList(request);
            if (response?.success) {
                setReportsData(response.data.docs);
                setTotalCount(response?.data.totalDocs);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const getReportsById = async (id) => {
        setLoading(true);
        try {
            const response = await api.report.getReportDetailsById(id);
            if (response?.success) {
                setLoading(false);
                setReportDataById([response.data]);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const contextValue = {
        loading,
        getUserList,
        data,
        getUserListById,
        userData, totalCount,
        setTotalCount,
        selectedRow,
        setSelectedRow,
        advisorUserChangeStatus,
        statusLoading,
        getAllReportsList,
        getReportsById,
        reportsData,
        reportDataById
    };

    return (
        <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
    );
};

UserProvider.propTypes = {
    children: PropTypes.node,
};

export const useUser = () => useContext(UserContext);
